module.exports = __webpack_public_path__ + "static/media/footer-โค้ง.4a9424fa.png";